import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiChatIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.06055 2.41895V2.41992C6.47528 4.16404 7.83596 5.52472 9.58008 5.93945H9.58105L9.83594 6L9.58105 6.06055H9.58008C7.83597 6.47528 6.47528 7.83597 6.06055 9.58008V9.58105L6 9.83594L5.93945 9.58105V9.58008C5.52472 7.83596 4.16404 6.47528 2.41992 6.06055H2.41895L2.16406 6L2.41895 5.93945H2.41992C4.16404 5.52472 5.52472 4.16404 5.93945 2.41992V2.41895L6 2.16406L6.06055 2.41895Z",
			fill: "#F7D2EC",
			stroke: "url(#paint0_linear_228_421)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.51465 13.2275C5.87439 14.7409 7.00383 15.9428 8.47363 16.4033L8.77246 16.4854L8.83594 16.5L8.77246 16.5146C7.25911 16.8744 6.0572 18.0038 5.59668 19.4736L5.51465 19.7725L5.5 19.8359L5.48535 19.7725C5.12561 18.2591 3.99617 17.0572 2.52637 16.5967L2.22754 16.5146L2.16406 16.5L2.22754 16.4854C3.74089 16.1256 4.9428 14.9962 5.40332 13.5264L5.48535 13.2275L5.5 13.1641L5.51465 13.2275Z",
			fill: "#F7D2EC",
			stroke: "url(#paint1_linear_228_421)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 9.14551C13.3731 10.5395 14.4596 11.6266 15.8535 12C14.4599 12.3733 13.3733 13.4599 13 14.8535C12.6266 13.4596 11.5395 12.3731 10.1455 12C11.5398 11.6269 12.6269 10.5398 13 9.14551Z",
			fill: "#F7D2EC",
			stroke: "url(#paint2_linear_228_421)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_228_421",
				x1: 6,
				y1: 0,
				x2: 6,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E128AA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEE020"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_228_421",
				x1: 5.5,
				y1: 11,
				x2: 5.5,
				y2: 22,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E128AA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEE020"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_228_421",
				x1: 13,
				y1: 7,
				x2: 13,
				y2: 17,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E128AA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEE020"
				})]
			})
		] })
	]
});
export default SvgAiChatIcon;
